// Dynamic Grid Editor Support
class DynamicGrid extends HTMLElement {
  constructor() {
    super();
    
    // Check if we're in design mode (try multiple methods)
    const isDesignMode = () => {
      const foxDesignMode = window.FoxThemeSettings && window.FoxThemeSettings.designMode;
      const shopifyDesignMode = window.Shopify && window.Shopify.designMode;
      const bodyClassDesignMode = document.body.classList.contains('shopify-design-mode');
      
      return foxDesignMode || shopifyDesignMode || bodyClassDesignMode;
    };
    
    if (isDesignMode()) {
      this.setupEditorEvents();
    }
  }
  
  setupEditorEvents() {
    // Listen for section events on the document (they bubble up)
    document.addEventListener("shopify:section:select", (event) => {
      // Check if this event is for our section
      if (event.target && event.target.contains(this)) {
        this.classList.add("editor-is-selected");
      }
    });
    
    document.addEventListener("shopify:section:deselect", (event) => {
      // Check if this event is for our section
      if (event.target && event.target.contains(this)) {
        this.classList.remove("editor-is-selected");
      }
    });
    
    // Add editor-is-selected class to individual cells when selected
    this.addEventListener("shopify:block:select", (event) => {
      event.target.classList.add("editor-is-selected");
    });
    
    // Remove editor-is-selected class from cells when deselected
    this.addEventListener("shopify:block:deselect", (event) => {
      event.target.classList.remove("editor-is-selected");
    });
  }
}

// Register the custom element
customElements.define("dynamic-grid", DynamicGrid);
